// Ricordarsi di aggiornare in clipper.js la posizione di ../wasm/clipper.wasm!
import ClipperModuleFactory from "./clipper.js";

let ClipperInitCallback = null;
let ClipperLocateCallback = null;

function SetClipperInitCallback(callable) {
    ClipperInitCallback = callable;
}

function SetClipperPathLocateCallback(callable) {
    ClipperLocateCallback = callable;
}

/**
 * @typedef {Object} ClipperLib.PointD
 * @property {number} x
 * @property {number} y
 */
/**
 * @typedef {Object} ClipperLib.RectD
 * @property {number} left
 * @property {number} top
 * @property {number} right
 * @property {number} bottom
 */

/**
 * @typedef {Object} ClipperLib.PathD
 *
 * @method ClipperLib.PathD.size()
 * @returns {number}
 *
 * @method ClipperLib.PathD.push_back(point)
 * @returns {ClipperLib.PointD} point
 *
 * @method ClipperLib.PathD.toArray()
 * @returns {Array}
 *
 * @method ClipperLib.PathD.toString()
 * @returns {String}
 *
 * @method ClipperLib.PathD.get(index)
 * @param {number} index
 * @returns {ClipperLib.PointD}
 */

/**
 * @typedef {Object} ClipperLib.PathsD
 *
 * @method ClipperLib.PathsD.size()
 * @returns {number}
 *
 * @method ClipperLib.PathsD.push_back(path)
 * @returns {ClipperLib.PathD} path
 *
 * @method ClipperLib.PathsD.toArray()
 * @returns {Array}
 *
 * @method ClipperLib.PathsD.toString()
 * @returns {String}
 *
 * @method ClipperLib.PathsD.get(index)
 * @param {number} s
 * @returns {ClipperLib.PathD}
 */

/**
 *
 * @class ClipperLib
 *
 * @method ClipperLib.MakePathD(s)
 * @param {string} s
 * @returns {ClipperLib.PathD}
 *
 * @method ClipperLib.isDebug()
 * @returns {boolean}
 *
 * @method ClipperLib.setDebug(state)
 * @param {boolean} state
 *
 * @method ClipperLib.AreaPaths(paths)
 * @param {ClipperLib.PathsD} paths
 * @returns {number}
 *
 * @method ClipperLib.RectClip(rect, subjects)
 * @param {ClipperLib.RectD} rect
 * @param {ClipperLib.PathsD} subjects
 * @param returns {ClipperLib.PathsD}
 *
 * @method ClipperLib.PointInPolygon(point, polygon)
 * @param {ClipperLib.PointD} point
 * @param {ClipperLib.PathD} polygon
 * @param returns {ClipperLib.PointInPolygonResult}
 */
let ClipperLib = {
    initialized: false,
    // Funzione invocata da printf di c++.
    print: function() {
        const args = ['%cClipperLib CPP Wrapper', 'font-weight: bold; color: #999999;', ...arguments];
        console.info.apply(null, args);
    },
    setStatus: function() {
        // const args = ['%cClipperLib', 'font-weight: bold; color: #999999;', ...arguments];
        // console.log.apply(null, args);
    },
    locateFile: function (path, prefix) {
        if (ClipperLocateCallback) {
            return ClipperLocateCallback(path.prefix);
        }
        // otherwise, use the default, the prefix (JS file's dir) + the path
        return prefix + path;
    },
    onRuntimeInitialized: function() {
        ClipperLib.PathD.prototype.toArray = function() {
            return new Array(this.size()).fill(null).map((_, id) => { return {...this.get(id)}; });
        };
        ClipperLib.PathD.prototype.toString = function() {
            let s = '[';
            const c = this.size();
            if (c) {
                for (let i = 0; i < c; i++) {
                    const point = this.get(i);
                    s += '('+point.x+','+point.y+')' + ' ';
                }
                s = s.substring(0, s.length - 1);
            }
            s += ']';
            return s;
        };

        ClipperLib.PathsD.prototype.toArray = function() {
            return new Array(this.size()).fill(null).map((_, id) => { return [...this.get(id).toArray()]; });
        };
        ClipperLib.PathsD.prototype.toString = function() {
            let s = '[';
            const c = this.size();
            if (c) {
                for (let i = 0; i < c; i++) {
                    const path = this.get(i);
                    s += '\n  ' + path.toString();
                }
                s += "\n";
            }
            s += ']';
            return s;
        };

        ClipperLib.setDebug(false);
        ClipperLib.initialized = true;
        if (ClipperInitCallback) {
            window.setTimeout(() => { ClipperInitCallback(ClipperLib) }, 1);
        }
    }
};

// Compila il codice wasm di clipper.
ClipperModuleFactory(ClipperLib);

export { SetClipperInitCallback, SetClipperPathLocateCallback, ClipperLib };
